import { createAction, props } from '@ngrx/store';
import { Customer } from '../../models/Customer';
import { UpdateCoinsModel } from '../../services/CustomerService';
import { GatewayCustomer } from '../../models/GatewayCustomer';
import { GatewayContact } from '../../models/GatewayContact';

export const getRegisteredCustomers = createAction('[Customer] Get Registered Customers');
export const getRegisteredCustomersSuccess = createAction(
  '[Customer] Get Registered Customers Success',
  props<{ customers: Customer[] }>()
);

export const getAllCustomers = createAction('[Customer] Get All Customers');
export const getAllCustomersSuccess = createAction(
  '[Customer] Get All Customers Success',
  props<{ customers: GatewayCustomer[] }>()
);

export const getCustomerById = createAction(
  '[Customer] Get Customer By Id',
  props<{ id: number }>()
);
export const getCustomerByIdSuccess = createAction(
  '[Customer] Get Customer By Id Success',
  props<{ customer: Customer }>()
);

export const getCustomerByIdFailure = createAction(
  '[Customer] Get Customer By Id Failure',
  props<{ error: any }>()
);

export const getCustomerByReflexId = createAction(
  '[Customer] Get Customer By Reflex Id',
  props<{ id: string }>()
);
export const getCustomerByReflexIdSuccess = createAction(
  '[Customer] Get Customer By Reflex Id Success',
  props<{ customer: Customer }>()
);

export const getCustomerByUserName = createAction(
  '[Customer] Get Customer By User Name',
  props<{ userName: string }>()
);
export const getCustomerByUserNameSuccess = createAction(
  '[Customer] Get Customer By User Name Success',
  props<{ customer: Customer }>()
);

export const getCurrentCustomer = createAction(
  '[Customer] Get Current Customer'
);
export const getCurrentCustomerSuccess = createAction(
  '[Customer] Get Current Customer Success',
  props<{ customer: Customer }>()
);
export const getCurrentCustomerFailure = createAction(
  '[Customer] Get Current Customer Failure',
  props<{ error: string }>()
);

export const clearCurrentCustomer = createAction(
  '[Customer] Clear Current Customer'
);
export const clearRegisteredCustomers = createAction(
  '[Customer] Clear Registered Customers'
);
export const clearAllCustomers = createAction(
  '[Customer] Clear All Customers'
);
export const clearSelectedCustomer = createAction(
  '[Customer] Clear Selected Customer'
);
export const clearSelectedGatewayCustomer = createAction(
  '[Customer] Clear Selected Gateway Customer'
);
export const getGatewayCustomerByReflexId = createAction(
  '[Customer] Get Gateway Customer By Reflex Id',
  props<{ id: string }>()
);
export const getGatewayCustomerByReflexIdSuccess = createAction(
  '[Customer] Get Gateway Customer By Reflex Id Success',
  props<{ customer: GatewayCustomer }>()
);

export const updateCoins = createAction(
  '[Customer] Update Coins',
  props<{ request: UpdateCoinsModel }>()
);

export const updateCoinsSuccess = createAction(
  '[Customer] Update Coins Success',
  props<{ customer: Customer }>()
);

export const getContactDataByNameShorthand = createAction(
  '[Customer] Get Contact Data By Name Shorthand',
  props<{ shorthand: string }>()
);

export const getContactDataByNameShorthandSuccess = createAction(
  '[Customer] Get Contact Data By Name Shorthand Success',
  props<{ contact: GatewayContact }>()
);

export const setEntraUserEnabledState = createAction(
  '[Customer] Set Entra User Enabled State',
  props<{ customerId: number; action: "enable" | "disable" }>()
);
export const setEntraUserEnabledStateSuccess = createAction(
  '[Customer] Set Entra User Enabled State Success',
  props<{ customers: Customer[] }>()
);

export const getCustomerEmployees = createAction(
  '[Customer] Get Customer Employees'
);
export const getCustomerEmployeesSuccess = createAction(
  '[Customer] Get Customer Employees Success',
  props<{ employees: Customer[] }>()
);